import Chart from 'react-apexcharts';
import { useSelector } from 'react-redux';
import { TimeInMS } from 'types/time';
import MDBox from '../MDBox/index';

const MDBoxCss = {
  // overflow: 'visible',
  borderRadius: '50%',
  height: '160px',
  width: '160px',
  backgroundColor: '#fff',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  paddingTop: '2rem',
};

function calculateDays(dateRange) {
  // Split the input string to get the two dates
  const [startDateStr, endDateStr] = dateRange.split('_');

  // Parse the dates into Date objects
  const startDate = new Date(`${startDateStr}T00:00:00`);
  const endDate = new Date(`${endDateStr}T00:00:00`);

  // Validate the dates
  if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
    throw new Error(
      'Invalid date format. Expected format: YYYY-MM-DD_YYYY-MM-DD',
    );
  }

  // Calculate the difference in milliseconds
  const diffInMs = endDate - startDate;

  // Convert the difference to hours
  const hours = diffInMs / (1000 * 60 * 60);

  return hours / 24;
}

const SensorHealth = props => {
  const data = useSelector(state => state.sensors.data);
  const rangeObj = useSelector(state => state.sensors.timeRange);

  // prettier-ignore
  const getConnectedPercentage = ( selectedTimeRangeInMinuets, lengthOfMeasuementsInMinuets ) => {
    return Math.ceil((lengthOfMeasuementsInMinuets / selectedTimeRangeInMinuets) * 100);
  };

  let getSeries = () => {
    const firstKey = Object.keys(data.minMaxRangeMeasurements)[0];
    const numberOfMeasuements = data.minMaxRangeMeasurements[firstKey].length;
    const selectedTimeRangeMs = rangeObj.value;
    let connectedValueInPercentage;

    switch (selectedTimeRangeMs) {
      case TimeInMS.Hour:
        connectedValueInPercentage = getConnectedPercentage(
          TimeInMS.Hour / 60000,
          numberOfMeasuements * 5,
        );
        break;
      case TimeInMS.Day:
        const now = new Date();
        const midnight = new Date(now);
        midnight.setHours(0, 0, 0, 0);

        // Time difference in milliseconds
        const diffMs = now - midnight;

        // Convert to minutes
        const diffMinutes = Math.floor(diffMs / 60000);

        // Expected number of measurements (every 5 minutes)
        const expectedCount = Math.floor(diffMinutes / 5);

        if (expectedCount === 0) return 0; // Prevent divide by zero

        const missingCount = expectedCount - numberOfMeasuements;
        const missingPercentage = (missingCount / expectedCount) * 100;

        connectedValueInPercentage =
          100 - Math.round(Math.max(0, Math.min(100, missingPercentage)));

        if (connectedValueInPercentage > 96) {
          connectedValueInPercentage = 100;
        }
        break;
      case TimeInMS.Week:
        connectedValueInPercentage = getConnectedPercentage(
          TimeInMS.Week / 60000,
          numberOfMeasuements * 15,
        );

        if (connectedValueInPercentage > 96) {
          connectedValueInPercentage = 100;
        }

        break;
      case TimeInMS.Month:
        connectedValueInPercentage = getConnectedPercentage(
          TimeInMS.Month / 60000,
          numberOfMeasuements * 15,
        );

        if (connectedValueInPercentage > 96) {
          connectedValueInPercentage = 100;
        }

        break;
      default:
        const numOfDays = calculateDays(selectedTimeRangeMs);

        if (numOfDays >= 7) {
          connectedValueInPercentage = getConnectedPercentage(
            numOfDays * 24 * 60,
            numberOfMeasuements * 15,
          );
        } else {
          connectedValueInPercentage = getConnectedPercentage(
            numOfDays * 24 * 60,
            numberOfMeasuements * 5,
          );
        }

        if (connectedValueInPercentage > 96) {
          connectedValueInPercentage = 100;
        }

        break;
    }
    if (connectedValueInPercentage > 100) {
      return [100, 0];
    } else {
      return [connectedValueInPercentage, 100 - connectedValueInPercentage];
    }
  };

  const series = getSeries();
  // console.log(series);

  const options = {
    series: series,
    labels: ['Connected', 'Disconnected'], // Labels for each slice
    legend: {
      position: 'bottom', // Position of the legend
    },
    colors: ['#3244E2', '#b0b0b0'],
    dataLabels: {
      formatter: function (val, opts) {
        // val is the percentage, opts.w.config.series gives the raw values
        const rawValue = opts.w.config.series[opts.seriesIndex];
        return `${Math.round(rawValue)}%`;
      },
    },
    tooltip: {
      fixed: {
        enabled: true,
        position: 'topCenter',
        offsetY: 0,
        offsetX: 0,
      },
      y: {
        formatter: function (val) {
          return `${Math.round(val)}%`;
        },
      },
    },
    plotOptions: {
      pie: {
        donut: {
          size: '70%',
          background: '#f4f4f4',
          labels: {
            show: true,
            total: {
              show: true,
              label: 'Sensor health',
              fontSize: '14px',
              fontWeight: 'bold',
              color: '#000',
              formatter: () => `${series[0]}%`,
            },
          },
        },
      },
    },
    // responsive: [
    //   {
    //     breakpoint: 480,
    //     options: {
    //       legend: {
    //         position: 'bottom',
    //       },
    //     },
    //   },
    // ],
  };

  return (
    <MDBox
      sx={{
        display: 'flex',
        justifyContent: 'center',
      }}
      className="pieContainer"
      item>
      <MDBox sx={MDBoxCss}>
        <Chart
          type="donut"
          options={options}
          series={options.series}
          width={270}
        />
        {/* <p>{healthValues[0]}</p> */}
        {/* <p>{healthValues[1]}</p> */}
      </MDBox>
    </MDBox>
  );
};

export default SensorHealth;
